<template>
<div class="chapter">
<div class="inner_page">
<h2 class="prect"><a id="pVIII"></a>Abbreviations</h2>
<table>
<tbody>
<tr>
<td>ADB</td>
<td>Asian Development Bank</td>
</tr>
<tr>
<td>AFP</td>
<td>Agence France Presse</td>
</tr>
<tr>
<td>AP</td>
<td>Arunachal Pradesh</td>
</tr>
<tr>
<td>APSCO</td>
<td>Asia Pacific Space Cooperation Organisation</td>
</tr>
<tr>
<td>ASEAN</td>
<td>Association of South East Asian Nations</td>
</tr>
<tr>
<td><i>BMJ</i></td>
<td><i>British Medical Journal</i></td>
</tr>
<tr>
<td>BRICS</td>
<td>Brazil, Russia, India, China and South Africa</td>
</tr>
<tr>
<td>CASS</td>
<td>Chinese Academy of Social Sciences</td>
</tr>
<tr>
<td>CCP</td>
<td>Chinese Communist Party</td>
</tr>
<tr>
<td>CPPCC</td>
<td>Chinese Peoples’ Political Consultative Conference</td>
</tr>
<tr>
<td>CCTV</td>
<td>China Central Television</td>
</tr>
<tr>
<td>CIC</td>
<td>China Investment Corporation</td>
</tr>
<tr>
<td>CIS</td>
<td>Commonwealth of Independent States</td>
</tr>
<tr>
<td>CMC</td>
<td>Central Military Commission</td>
</tr>
<tr>
<td><i>CSM</i></td>
<td><i>Christian Science Monitor</i></td>
</tr>
<tr>
<td>CSTO</td>
<td>Collective Security Treaty Organisation</td>
</tr>
<tr>
<td>DPJ</td>
<td>Democratic Party of Japan</td>
</tr>
<tr>
<td>DPP</td>
<td>Democratic Progressive Party [Taiwan]</td>
</tr>
<tr>
<td>EAS</td>
<td>East Asia Summit</td>
</tr>
<tr>
<td><i>EC</i></td>
<td><i>The Economist</i></td>
</tr>
<tr>
<td>ETIM</td>
<td>East Turkestan Islamic Movement</td>
</tr>
<tr>
<td>FAO</td>
<td>Food and Agriculture Organization</td>
</tr>
<tr>
<td>FDA</td>
<td>[US] Food and Drug Administration</td>
</tr>
<tr>
<td>FDI</td>
<td>foreign direct investment</td>
</tr>
<tr>
<td><i>FT</i></td>
<td><i>Financial Times</i></td>
</tr>
<tr>
<td>GDP</td>
<td>gross domestic product</td>
</tr>
<tr>
<td>GDFCF</td>
<td>gross domestic fixed capital formation</td>
</tr>
<tr>
<td><a id="pIX"></a>GONGO</td>
<td>government-organised non-governmental organisation</td>
</tr>
<tr>
<td>ICC</td>
<td>International Criminal Court</td>
</tr>
<tr>
<td>ICOR</td>
<td>Incremental Capital–Output Ratio</td>
</tr>
<tr>
<td><i>IHT</i></td>
<td><i>International Herald Tribune</i></td>
</tr>
<tr>
<td>IMF</td>
<td>International Monetary Fund</td>
</tr>
<tr>
<td>IPO</td>
<td>initial public offering</td>
</tr>
<tr>
<td><i>Jane’s</i></td>
<td><i>Jane’s Defence Weekly</i></td>
</tr>
<tr>
<td><i>LA</i></td>
<td><i>(Daily Times): Los Angeles (Daily) Times</i></td>
</tr>
<tr>
<td>NATO</td>
<td>North Atlantic Treaty Organization</td>
</tr>
<tr>
<td>NBS</td>
<td>National Bureau of Statistics</td>
</tr>
<tr>
<td>NDRC</td>
<td>National Development and Reform Commission</td>
</tr>
<tr>
<td>NGO</td>
<td>non-governmental organisation</td>
</tr>
<tr>
<td>NIEs</td>
<td>newly industrialising economies</td>
</tr>
<tr>
<td>NPC</td>
<td>National People’s Congress</td>
</tr>
<tr>
<td>NRI</td>
<td>non-resident Indian</td>
</tr>
<tr>
<td><i>NYT</i></td>
<td><i>New York Times</i></td>
</tr>
<tr>
<td>OECD</td>
<td>Organisation for Economic Cooperation and Development</td>
</tr>
<tr>
<td>OEM</td>
<td>original equipment manufacturing</td>
</tr>
<tr>
<td>PBC</td>
<td>People’s Bank of China</td>
</tr>
<tr>
<td>PLA</td>
<td>People’s Liberation Army</td>
</tr>
<tr>
<td>PRC</td>
<td>People’s Republic of China</td>
</tr>
<tr>
<td>PRD</td>
<td>Pearl River Delta</td>
</tr>
<tr>
<td>PPP</td>
<td>purchasing power parity</td>
</tr>
<tr>
<td>R&amp;D</td>
<td>research and development</td>
</tr>
<tr>
<td>RMB</td>
<td><i>renminbi</i></td>
</tr>
<tr>
<td><i>SCMP</i></td>
<td><i>South China Morning Post</i></td>
</tr>
<tr>
<td>SCO</td>
<td>Shanghai Cooperation Organization</td>
</tr>
<tr>
<td>SEPA</td>
<td>State Environmental Protection Agency</td>
</tr>
<tr>
<td>SLEs</td>
<td>state-linked enterprises</td>
</tr>
<tr>
<td>SMEs</td>
<td>small and medium-sized enterprises</td>
</tr>
<tr>
<td><i>SMH</i></td>
<td><i>Sydney Morning Herald</i></td>
</tr>
<tr>
<td>SOEs</td>
<td>state-owned enterprises</td>
</tr>
<tr>
<td>SIPRI</td>
<td>Stockholm International Peace Research Institute</td>
</tr>
<tr>
<td>TI</td>
<td>Transparency International</td>
</tr>
<tr>
<td>TVEs</td>
<td>town and village enterprises</td>
</tr>
<tr>
<td>UNCTAD</td>
<td>United Nations Conference on Trade and Development</td>
</tr>
<tr>
<td>UNDP</td>
<td>United Nations Development Programme</td>
</tr>
<tr>
<td>UNESCO</td>
<td>United Nations Educational, Scientific and Cultural Organization</td>
</tr>
<tr>
<td>USCESRC</td>
<td>US–China Economic and Security Review Commission</td>
</tr>
<tr>
<td><a id="pX"></a>UWSA</td>
<td>United Wa State Army [Burma]</td>
</tr>
<tr>
<td>WHO</td>
<td>World Health Organization</td>
</tr>
<tr>
<td><i>WSJ</i></td>
<td><i>Wall Street Journal</i></td>
</tr>
<tr>
<td>WTO</td>
<td>World Trade Organization</td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// list_of_abbreviations.vue?48fd5b88